import { TourBuilderStoreEvents } from '../../events/TourBuilderStoreEvents';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { Scene, SceneGuid, SceneHelper } from '../../types/Scene';
import { SceneLink, SceneLinkGuid } from '../../types/SceneLink';
import { IPanorama } from '@ael/core-api';

export type DeleteLinkUseCase = {
  linkGuid: SceneLinkGuid;
  panorama: IPanorama;
};

export const deleteLinkUseCaseHandler = (
  params: DeleteLinkUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC,
  eventHandlers: TourBuilderStoreEvents
): Partial<TourBuilderStore> => {
  const store = getState();
  const linkToDelete = store.links.get(params.linkGuid);
  if (!linkToDelete) {
    return store;
  }
  const newLinks = new Map<SceneLinkGuid, SceneLink>(store.links);
  newLinks.delete(params.linkGuid);

  const scene = store.scenes.get(linkToDelete.originTourSceneGuid);
  const newScenes = new Map<SceneGuid, Scene>(store.scenes);
  if (scene) {
    const updatedScene = SceneHelper.removeLink(scene, linkToDelete.guid);
    newScenes.set(updatedScene.guid, updatedScene);
  }

  eventHandlers.onLinkDeleted.notify({ guid: params.linkGuid });

  // No need to await
  services.storageClient.deleteLink({
    guids: [params.linkGuid],
  });

  return {
    scenes: newScenes,
    links: newLinks,
  };
};
